import {PayloadAction, createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {ENV} from '../../../../Utils/_helpers/EnvHelper'
import {
  IntegrationApp,
  IntegrationPageSlice,
  IntegrationPageState,
  SelectActiveIntegrationPaylod,
} from './Types'
import {startLoadding, stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import axios from 'axios'

const API_URL = ENV().REACT_APP_API_URL

// Thunk Handler
export const fetchExternalProviders: any = createAsyncThunk(
  'FetchExternalProviders',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.get(`${API_URL}external-provider`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const fetchActiveIntegrationApp: any = createAsyncThunk(
  'FetchActiveIntegrationApp',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.get(`${API_URL}integration-app/active`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const activateClickFunnelsIntegration: any = createAsyncThunk(
  'ActivateClickFunnelsIntegrationApp',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}clickfunnels/activate`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const deactivateClickFunnelsIntegration: any = createAsyncThunk(
  'DeactivateClickFunnelsIntegrationApp',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.delete(`${API_URL}clickfunnels/deactivate`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const activateClickFunnelsClassicIntegration: any = createAsyncThunk(
  'ActivateClickFunnelsClassicIntegration',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}clickfunnels/activate/classic`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const deactivateClickFunnelsClassicIntegration: any = createAsyncThunk(
  'DeactivateClickFunnelsClassicIntegration',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.delete(`${API_URL}clickfunnels/deactivate/classic`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const activateZapierIntegration: any = createAsyncThunk(
  'ActivateZapierIntegrationApp',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}zapier/activate`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const deactivateZapierIntegration: any = createAsyncThunk(
  'DeactivateZapierIntegrationApp',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.delete(`${API_URL}zapier/deactivate`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const activateGhlIntegration: any = createAsyncThunk(
  'ActivateGhlIntegrationApp',
  async (data: any, thunkApi) => {
    const {code} = data
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}ghl/activate?code=${code}`, null, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const activateJobAdderIntegration: any = createAsyncThunk(
  'ActivateJobAdderIntegrationApp',
  async (data: any, thunkApi) => {
    const {code} = data
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}jobadder/activate?code=${code}`, null, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const activateHubSpotIntegration: any = createAsyncThunk(
  'ActivateHubSpotIntegrationApp',
  async (data: any, thunkApi) => {
    const {code} = data
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}hubspot/activate?code=${code}`, null, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const deactivateGhlIntegration: any = createAsyncThunk(
  'DeactivateGhlIntegrationApp',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.delete(`${API_URL}ghl/deactivate`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const deactivateJobAdderIntegration: any = createAsyncThunk(
  'DeactivateJobAdderIntegrationApp',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.delete(`${API_URL}jobadder/deactivate`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const activateWordpressIntegration: any = createAsyncThunk(
  'ActivateWordpressIntegrationApp',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}wordpress/activate`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const deactivateWordpressIntegration: any = createAsyncThunk(
  'DeactivateWordpressIntegrationApp',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.delete(`${API_URL}wordpress/deactivate`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const deactivateHubSpotIntegration: any = createAsyncThunk(
  'DeactivateHubSpotIntegrationApp',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.delete(`${API_URL}hubspot/deactivate`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const activateActiveCampaignIntegration: any = createAsyncThunk(
  'ActivateActiveCampaignIntegrationApp',
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}activecampaign/activate`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const deactivateActiveCampaignIntegration: any = createAsyncThunk(
  'DeactivateActiveCampaignIntegrationApp',
  async (data, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.delete(`${API_URL}activecampaign/deactivate`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

// State
const initialState: IntegrationPageState = {
  externalProviders: [],
  activeIntegration: [],
  selectedExternalProvider: null,
  selectedActiveIntegration: null,
  refetch: false,
  activeIntegrationIDs: [],
}

const integrationData = createSlice({
  name: 'IntegrationData',
  initialState,
  reducers: {
    setSelectedExternalProvider: (state, externalProviderId: any) => {
      const selectedData = state.externalProviders.find((el) => el._id === externalProviderId)
      if (!selectedData) {
        return {...state}
      }
      return {...state, selectedExternalProvider: selectedData}
    },
    setSelectedActiveIntegration: (
      state,
      {payload}: PayloadAction<SelectActiveIntegrationPaylod>
    ) => {
      if (!payload || (payload && !payload.externalProviderId) || (payload && !payload.userId)) {
        return {...state}
      }

      const selectedData = state.activeIntegration.find(
        (el) => el.externalProvider === payload.externalProviderId && el.user === payload.userId
      )

      if (!selectedData) {
        return {...state}
      }

      return {...state, selectedActiveIntegration: selectedData}
    },
    resetSelectedIntegrationData: (state, {payload}) => {
      return {...state, selectedActiveIntegration: null, selectedExternalProvider: null}
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchExternalProviders.fulfilled, (state, action) => {
      // console.debug('[integrationData][extraReducers][fetchExternalProviders] ', action)
      return {...state, externalProviders: action?.payload, refetch: false}
    })

    builder.addCase(fetchActiveIntegrationApp.fulfilled, (state, action) => {
      // console.debug('[integrationData][extraReducers][fetchActiveIntegrationApp] ', action)
      // also add update external provider identifier
      let activeIds: string[] = []
      if (action && action.payload && Array.isArray(action.payload)) {
        activeIds = action.payload.map((el: IntegrationApp) => el.externalProvider)
      }

      return {
        ...state,
        activeIntegration: action?.payload,
        activeIntegrationIDs: activeIds,
        refetch: false,
      }
    })

    builder.addCase(activateClickFunnelsIntegration.fulfilled, (state, action) => {
      // console.debug(
      //   '[integrationData][extraReducers][activateClickFunnelsIntegration] response ',
      //   action
      // )
      return {...state, refetch: true}
    })

    builder.addCase(deactivateClickFunnelsIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(activateClickFunnelsClassicIntegration.fulfilled, (state, action) => {
      // console.debug(
      //   '[integrationData][extraReducers][activateClickFunnelsIntegration] response ',
      //   action
      // )
      return {...state, refetch: true}
    })

    builder.addCase(deactivateClickFunnelsClassicIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(activateZapierIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(deactivateZapierIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(activateGhlIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(deactivateGhlIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(activateJobAdderIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(activateHubSpotIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(deactivateHubSpotIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(deactivateJobAdderIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(activateWordpressIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(deactivateWordpressIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(activateActiveCampaignIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })

    builder.addCase(deactivateActiveCampaignIntegration.fulfilled, (state, action) => {
      return {...state, refetch: true}
    })
  },
})

// Selector
export const getExternalProviders = (state: IntegrationPageSlice) =>
  state.integration.externalProviders

export const getExternalProviderById = (id: any) => (state: IntegrationPageSlice) =>
  state.integration.externalProviders.find((el) => el._id === id)

export const getIntegrationRefetchDataStatus = (state: IntegrationPageSlice) =>
  state.integration.refetch

export const getActivateIntegrationByUser =
  (userId: any, externalProviderId: any) => (state: IntegrationPageSlice) =>
    state.integration.activeIntegration.find(
      (el) => el.user === userId && el.externalProvider === externalProviderId
    )

export const getActivateIntegrationIds = (state: IntegrationPageSlice) =>
  state.integration.activeIntegrationIDs

// Export reducer
export const {
  setSelectedActiveIntegration,
  setSelectedExternalProvider,
  resetSelectedIntegrationData,
} = integrationData.actions

export default integrationData.reducer
